import React from "react";
import {
  EditDetailsTable,
  PRStyledCell
} from "src/app/purchaseRequisition/PR.styles";
import MaterialTable, { Column } from "material-table";
import { TableLoadingComponent } from "src/app/shared/components/loading";
import { useTableStyles } from "../../../../dataTable/docFlow/docFlowTable.styles";
import { DocFlowItem } from "src/app/docFlows/domains/prpo/poItem";
import { ItemTableCellComponent } from "../../../itemTableCell.component";
import {
  CustomFastAsyncSelect,
  CustomFastDate,
  CustomFastInput,
  CustomFastSelect
} from "src/app/shared/components/form";
import { MasterService } from "src/app/shared/domains/master/master.service";
import { DateTime } from "luxon";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import ItemDetailsMoreButton from "./itemDetailsMoreButton";
import {
  calcValueForCandex,
  fetchCurrencyConversion,
  getCondtions,
  isItDeLslCXMLVendor,
  isItGbCandexIFrameVendor,
  isItIeCandexIFrameVendor,
  removeDecimal
} from "../../helper";
import { FeaturesContext } from "src/app/shared/domains/core/pataflag.context";
import { Features } from "src/app/shared/domains/core/pataflag";
import { isNil } from "ramda";
import DeliveryAddressComponent from "./deliveryAddress.component";
import { SpenderComponent } from "./spender.component";
import { DISPATCH_TYPES } from "../../EditRequestAllLinesWrapper";
import {
  useFetchCountryRegion,
  useFetchTaxCode
} from "src/app/shared/domains/master/master.hooks";
import { useFetchCurrencySetFromSAP } from "../../hooks/mulitlineEditPr.hooks";
import DocumentFlow from "src/app/docFlows/domains/documentFlow/documentFlow";
import { Formatter } from "src/app/shared/components/amount-formatter";
import { showAmountOrAmountWithIcon } from "src/app/docFlows/helpers/functions";
import { PlantComponent, UomComponent } from "./plant.component";
import { PunchOutCatDetails } from "src/app/shared/domains/master/punchOutCatalogDetails";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#4caf50"
    },
    secondary: {
      main: "#ff9100"
    }
  }
});

type newItemDetailsTableProps = {
  currencyDecimals: any;
  lineItems: DocFlowItem[];
  documentFlow: DocumentFlow;
  setSelectedData: React.Dispatch<any>;
  dispatchMethod: any;
  showCBbasedOnSupplierStatus: any;
  setFinalResendPoData: Function;
  finalResendPodata: any;
  punchOutCatalogDetails: PunchOutCatDetails;
  disbaleItemDetails?: boolean;
  vertexData?: any;
};

export const NewItemDetailsTable = (props: newItemDetailsTableProps) => {
  const { docFlowTableClass, removeBorderForCheckBox } = useTableStyles({});
  const { hasFeature } = React.useContext(FeaturesContext);
  const firstLineItem = props.lineItems[0];
  React.useEffect(() => {
    console.log("=========== CANDEX ITEMS ===========");

    props.lineItems.forEach((item: any) => {
      console.log(console.log("ITEM:", item));
      console.log("DADA:", JSON.stringify(item, null, 2));
    });
  }, [props.lineItems]);
  const { disbaleItemDetails = false } = props;
  const fieldLevelConditions = getCondtions(firstLineItem);
  const { data: taxCodes } = useFetchTaxCode(
    firstLineItem?.CompCode || props.documentFlow.POCompanyCode,
    firstLineItem?.SystemAlias
  );
 
  const { data: countryRegions } = useFetchCountryRegion(
    firstLineItem?.SystemAlias
  );
  const { data: currencySet } = useFetchCurrencySetFromSAP(
    firstLineItem?.SystemAlias
  );
  const [decimal, setDecimal] = React.useState<number | null>(null);
  const [priceToBeEdited, setPriceToBeEdited] = React.useState<boolean>(false);
  const [quantityToBeEdited, setQuantityToBeEdited] = React.useState<boolean>(
    false
  );
  const [perUnitToBeEdited, setPerUnitToBeEdited] = React.useState<boolean>(
    false
  );

  const [sortedData, setData] = React.useState([]);

  React.useEffect(() => {
    if (props.lineItems.length) {
      if (props.lineItems.length > 2) {
        if (hasFeature(Features.RC_EDIT_PAGE_SORT_ITEMS_IN_TABLE)) {
          const sortedData = sortLineItemsData(props.lineItems)
          setData(sortedData);
        } else {
          setData(props.lineItems);
        }
      } else {
        setData(props.lineItems);
      }
    }
  }, [props.lineItems])

  React.useEffect(() => {
    for (let i = 1; i <= sortedData.length; i++) {
      let checkBox: HTMLElement = document.querySelector(
        `#itemDetails > div > div > div > div > div > div > table > tbody > tr:nth-child(${i}) > td`
      );
      let spanElement: any = checkBox.children[0];
      checkBox.style.border = "none";
      spanElement.style.marginLeft = "5px";
    }
  }, [sortedData.length])

  const isItCandex_IFrame = () => {
    if (hasFeature(Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION)) {
      return props.punchOutCatalogDetails?.protocol === "OCI";
    }
    return (
      (isItGbCandexIFrameVendor(props.documentFlow) ||
        isItIeCandexIFrameVendor(props.documentFlow)) &&
      hasFeature(Features.RC_ADD_FROM_CANDEX)
    );
  };

  // const isCandexServiceItem = (item: any) =>
  //   isItCandex_IFrame() && item?.ITEMSOURCE === "X";
const isCandexServiceItem = (item: any) => {
  if (!isItCandex_IFrame()) {
    return false;
  }

  const price = getCondtions(item).isItFO
    ? Number(item.PrPriceRaw)
    : Number(item.PrNetPriceRaw);

  return price === 1;
};
 
const roundDisplayValue = (value: any, decimals = 2) => {
  if (value == null || value === "") return value;

  const num = Number(value);
  if (isNaN(num)) return value;

  return Number(num.toFixed(decimals));
};

const getDisplayedUnitPrice = (item: any) => {
  const price = getCondtions(item).isItFO
    ? item.PrPriceRaw
    : item.PrNetPriceRaw;

  return roundDisplayValue(price);
};
// const getDisplayedSubtotal = (item: any) => {
//     const quantity = Number(item.PrQuantityRaw) || 1;
//     const rawPrice = getCondtions(item).isItFO ? item.PrPriceRaw : item.PrNetPriceRaw;
//     const rawTotal = rawPrice * quantity;

//   if (isCandexGoodsItem(item)) {
//   return getGoodsPriceWithIncrement(rawPrice, quantity) * quantity;
// }

//     return item.PrPrice !== undefined && item.PrPrice !== null
//       ? item.PrPrice
//       : rawTotal;
//   };
const getDisplayedSubtotal = (item: any) => {
  const qty = Number(item.PrQuantityRaw) || 1;

  const price = getCondtions(item).isItFO
    ? item.PrPriceRaw
    : item.PrNetPriceRaw;

  const subtotal =
    item.PrPrice ?? (price * qty) / item.PrNetPriceUnit;

  return roundDisplayValue(subtotal);
};



  const isItDeLsl_CXML = () => {
    if (hasFeature(Features.RC_174982_PUNCHOUT_AUTOMATED_SOLUTION)) {
      if (hasFeature(Features.RC_178782_ENABLE_EDIT_PSLPR_WITH_PUNCHOUT_VENDOR)) {
        return props.punchOutCatalogDetails?.protocol === "cXML" && firstLineItem?.Psl_ID === ""
      } else {
        return props.punchOutCatalogDetails?.protocol === "cXML"
      }
    } else if (hasFeature(Features.RC_178782_ENABLE_EDIT_PSLPR_WITH_PUNCHOUT_VENDOR)) {
      return props.punchOutCatalogDetails?.protocol === "cXML" && firstLineItem?.Psl_ID === ""
    }
    return (
      isItDeLslCXMLVendor(props.documentFlow) &&
      hasFeature(Features.ADD_ITEM_FROM_CXML_LSL)
    );
  };

  const applyPlantChanges = value => {
    props.dispatchMethod({
      type: DISPATCH_TYPES.COMMON_IN_ALL_LINE_ITEMS,
      payload: { ...value }
    });
  };

  const applyChanges = async (vals: any, itemNo: string) => {
    await delete vals.Spender_Resend;
    if (
      hasFeature(Features.RC_164177_SHOW_RESEND_PO_PDF_BUTTON_ON_CONDITIONS) &&
      vals?.PrRequisitioner
    ) {
      props.dispatchMethod({
        type: DISPATCH_TYPES.EDIT_LINE_ITEMS,
        payload: {
          lineNo: itemNo,
          editedValues: vals,
          spendorChanged: true
        }
      });
    } else {
      props.dispatchMethod({
        type: DISPATCH_TYPES.EDIT_LINE_ITEMS,
        payload: {
          lineNo: itemNo,
          editedValues: vals
        }
      });
    }
  };

  const applyPriceChanges = (vals: any, itemNo: string) => {
    props.dispatchMethod({
      type: DISPATCH_TYPES.UPDATE_PRICE_FIELDS,
      payload: {
        lineNo: itemNo,
        editedValues: vals
      }
    });
  };

  const handleDeliveryDateChange = (value: any, item: DocFlowItem) => {
    let tempDate = DateTime.fromISO(value).toFormat("yyyyMMdd");
    if (tempDate === "Invalid DateTime") {
      tempDate = item.PrDeliveryDate;
    }

    applyChanges(
      {
        PrDeliveryDate: tempDate
      },
      item.PrItem
    );
  };

  const handleCurrencyChanges = (currency: {
    label: string;
    value: string;
  }) => {
    const tempDecimal: {
      currency: string;
      decimal: string;
    } = props.currencyDecimals?.filter(
      curr => curr.currency === currency.value
    )[0];
    const finalDecimal = tempDecimal?.decimal
      ? parseInt(tempDecimal?.decimal)
      : null;
    setDecimal(finalDecimal);
    const newAllItems = props.lineItems.map(item => {
      let price = fieldLevelConditions.isItFO
        ? item.PrPriceRaw
        : item.PrNetPriceRaw;

      price = removeDecimal(price, finalDecimal);
      const finalprice = fieldLevelConditions.isItFO
        ? { PrPriceRaw: price }
        : { PrNetPriceRaw: price };
      const finalQty = {
        PrQuantityRaw: removeDecimal(item.PrQuantityRaw, finalDecimal)
      };
      const finalPerUnit = {
        PrNetPriceUnit: removeDecimal(item.PrNetPriceUnit, finalDecimal)
      };
      const newTotal: number =
        (price * finalQty.PrQuantityRaw) / finalPerUnit.PrNetPriceUnit;

      return {
        ...item,
        ...finalprice,
        ...finalQty,
        ...finalPerUnit,
        PrPrice: newTotal,
        PrCurrency: currency.value
      };
    });

    fetchCurrencyConversion(
      props.showCBbasedOnSupplierStatus,
      firstLineItem.Threshold_currency,
      currency.value
    )
      .then(result => {
        if (!result.ToCurrency && !result.ToAmount) {
          // show some warning msg... like selected currency is unable to convert to
          // threshold currency (EUR), Kindly change the currency or else system will consider
          // default currency as threshold currency.
          console.log("Currency error");
          props.dispatchMethod({
            type: DISPATCH_TYPES.HANDLE_CURRENCY_CHANGE,
            payload: {
              currencyConversionValue: 1,
              currencyWarning: `Currency conversion failed for ${result.prCurrency}: System will consider only value without currency conversion`,
              newAllItems: newAllItems
            }
          });
        } else {
          props.dispatchMethod({
            type: DISPATCH_TYPES.HANDLE_CURRENCY_CHANGE,
            payload: {
              currencyConversionValue:
                Number(result.ToAmount?.trim()) / result.amount,
              currencyWarning: "",
              newAllItems: newAllItems
            }
          });
        }
      })
      .catch(e => {
        props.dispatchMethod({
          type: DISPATCH_TYPES.HANDLE_CURRENCY_CHANGE,
          payload: {
            currencyConversionValue: 1,
            currencyWarning: "",
            newAllItems: newAllItems
          }
        });
      });

    // props.dispatchMethod({ type: DISPATCH_TYPES.HANDLE_CURRENCY_CHANGE, payload: newAllItems })
  };

const handlePriceChanges = (value: any, item: DocFlowItem) => {
 let tempValue = value;
  const itemConditions = getCondtions(item);

  if (!value || value <= 0) {
    tempValue = itemConditions.isItFO
      ? item.PrPriceRaw
      : item.PrNetPriceRaw;
  }

  const finalPrice = removeDecimal(tempValue, decimal);

  const price = itemConditions.isItFO
    ? { PrPriceRaw: finalPrice }
    : { PrNetPriceRaw: finalPrice };



 const effectivePrice = finalPrice;

  if (hasFeature(Features.RC_175143_EDIT_NEW_PSL_ITEM_TOTAL_ISSUE_FIX)) {
    if (item.PrQuantityRaw !== "" && item.PrNetPriceUnit !== null) {
      const newTotal =
        (effectivePrice * item.PrQuantityRaw) / item.PrNetPriceUnit;

      applyPriceChanges(
        {
          ...price,
          PrPrice: newTotal
        },
        item.PrItem
      );
    } else {
      applyPriceChanges(price, item.PrItem);
    }
  } else {
    const newTotal =
      (effectivePrice * item.PrQuantityRaw) / item.PrNetPriceUnit;

    applyPriceChanges(
      {
        ...price,
        PrPrice: newTotal
      },
      item.PrItem
    );
  }
};
const handleQtyChanges = (value: any, item: DocFlowItem) => {
  let tempValue = value;

  if (!value || value <= 0) {
    tempValue = item.PrQuantityRaw;
  }

  const finalQty = removeDecimal(tempValue, decimal);

  const itemConditions = getCondtions(item);

  const price = itemConditions.isItFO
    ? item.PrPriceRaw
    : item.PrNetPriceRaw;

  const subTotal =
    (price * finalQty) / item.PrNetPriceUnit;

  applyPriceChanges(
    {
      PrQuantityRaw: finalQty,
      PrPrice: subTotal
    },
    item.PrItem
  );
};
  const handlePerUnitChanges = (value: any, item: DocFlowItem) => {
    let tempValue = value;
    if (!value || value <= 0) {
      tempValue = item.PrNetPriceUnit;
    }
    let finalPerUnit = removeDecimal(tempValue, decimal);
    const price = fieldLevelConditions.isItFO
      ? item.PrPriceRaw
      : item.PrNetPriceRaw;
    if (hasFeature(Features.RC_175143_EDIT_NEW_PSL_ITEM_TOTAL_ISSUE_FIX)) {
      if (item.PrQuantityRaw !== "" && price !== 0) {
        const newTotal: number = (price * item.PrQuantityRaw) / finalPerUnit;
        applyPriceChanges(
          { PrNetPriceUnit: finalPerUnit, PrPrice: newTotal },
          item.PrItem
        );
      } else {
        applyPriceChanges({ PrNetPriceUnit: finalPerUnit }, item.PrItem);
      }
    } else {
      const newTotal: number = (price * item.PrQuantityRaw) / finalPerUnit;
      applyPriceChanges(
        { PrNetPriceUnit: finalPerUnit, PrPrice: newTotal },
        item.PrItem
      );
    }
  };

  const checkIfMaterialDisabled = (item: any) => {
    const fieldLevelConditions = getCondtions(item);
    if (isItDeLsl_CXML()) return true; // disabled for cXML Supplier PRs
    if (item?.isItCopiedLineItem) {
      // if its copied line , material should be disabled for easy request and
      // for rest should be enabled irrespective of other conditions
      if (fieldLevelConditions.isItEasyRequestPR) {
        return true;
      } else return false;
    }
    return (
      fieldLevelConditions.isItFO ||
      (!fieldLevelConditions.isItFO && fieldLevelConditions.isTherePO) ||
      (!fieldLevelConditions.isItFO && fieldLevelConditions.isThereGR) ||
      (!fieldLevelConditions.isItFO && fieldLevelConditions.isThereIR)
    );
  };

  const disableField = (isItMandatoryOrSoleSource: boolean, value: string) => {
    if (!isItMandatoryOrSoleSource) {
      return false;
    }
    if (value) {
      return true;
    }
    return false;
  };

  function applyChange(value: any) {
    props.dispatchMethod({
      type: DISPATCH_TYPES.COMMON_IN_ALL_LINE_ITEMS,
      payload: { ...value, spendorChanged: true, status: "T" }
    });
    setPoSendingOptionsData(value.Spender_Resend);
  }

  const setPoSendingOptionsData = spender => {
    const poSendingOptionsData = props.finalResendPodata.postData?.status
      ? { ...props.finalResendPodata.postData, Spender_Resend: spender }
      : {
        Requester_Resend: props.lineItems[0].Requester_Resend,
        Spender_Resend: spender,
        Supplier_Resend: props.lineItems[0].Supplier_Resend,
        Other_Resend: props.lineItems[0].Other_Resend,
        Hide_Price: props.lineItems[0].Hide_Price,
        Title_resend: props.lineItems[0].Title_resend
      };
    props.setFinalResendPoData({
      changedStatus: true,
      postData: poSendingOptionsData
    });
  };

  const applyUomChanges = value => {
    props.dispatchMethod({
      type: DISPATCH_TYPES.COMMON_IN_ALL_LINE_ITEMS,
      payload: { ...value }
    });
  };

  // Below Code is to filter only NSP PRs which were craeted through Easy Request

  const checkIsItEasyReqNSPWithPSL = () => {
    if (props.lineItems[0].ExtReqNo && props.lineItems[0].Psl_ID) {
      const firstTwoChars = props.lineItems[0].Psl_ID.slice(0, 2);
      if (
        firstTwoChars === "PP" ||
        firstTwoChars === "LP" ||
        firstTwoChars === "CP"
      ) {
        console.log(props.lineItems[0].Psl_ID);
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const disableFieldsForNSP = hasFeature(
    Features.RC_177560_DISABLE_SOME_FILEDS_FOR_NSP_PR
  )
    ? checkIsItEasyReqNSPWithPSL()
    : false;

  // End

  const PRDetailColumns = (): Column<any>[] => {
    const columns = [
      {
        title: "#",
        sorting: false,
        field: "PrItem",
        cellStyle: { width: "2%" },
        render: (item: DocFlowItem, i) => (
          <ItemTableCellComponent
            key={i}
            values={[item.PrItem]}
            hideLeadingZeros={true}
          />
        )
      },
      {
        title: "Material",
        field: "PrMaterial",
        sorting: false,
        cellStyle: { width: "10%" },
        render: (item: any, i) => {
          let disabled = checkIfMaterialDisabled(item);
          return (
            <CustomFastAsyncSelect
              styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                valueContainer: (base, state) => ({ ...base, paddingLeft: 0 }),
                indicatorSeparator: (base, state) => ({
                  ...base,
                  display: "none"
                }),
                control: (base, state) => ({
                  ...base,
                  backgroundColor: "transparent",
                  borderStyle: "none",
                  borderRadius: 0,
                  borderBottom: disabled
                    ? "1px solid hsl(0,0%,90%)"
                    : "1px solid",
                  marginBottom: 7
                })
              }}
              menuPortalTarget={document.body}
              isMulti={false}
              onLoadLimit={2}
              clearable={false}
              onLoad={x =>
                MasterService.fetchMaterial(x, [item.Plant], item.SystemAlias)
              }
              customDisplay={option =>
                option.label
                  ? `${option.value} - ${option.label}`
                  : option.value
              }
              disabled={hasFeature(Features.RC_178185_DISABLE_FILEDS_FOR_PUNCHOUT_CATALOG) ? ((props.punchOutCatalogDetails?.protocol === "cXML" && firstLineItem?.Psl_ID === "") ? false : disabled) : disabled}
              initialValue={
                item.PrMaterial
                  ? {
                    value: item.PrMaterial.replace(/^0+/, "")
                  }
                  : {}
              }
              onChange={value =>
                value
                  ? applyChanges(
                    {
                      PrMaterial: value.value
                    },
                    item.PrItem
                  )
                  : null
              }
              customTooltipMessage="Type to find the materials"
            />
          );
        }
      },
      {
        title: "Description",
        field: "PrItemTxt",
        cellStyle: { width: "12%" },
        sorting: false,
        render: (item: DocFlowItem, i) => {
          const fieldLevelConditions = getCondtions(item);
          return (
            <CustomFastInput
              disabled={hasFeature(Features.RC_178185_DISABLE_FILEDS_FOR_PUNCHOUT_CATALOG) ? ((props.punchOutCatalogDetails?.protocol === "cXML" && firstLineItem?.Psl_ID === "") ? true : (!fieldLevelConditions.isItZSIM || disbaleItemDetails || disableFieldsForNSP)) : (!fieldLevelConditions.isItZSIM || disbaleItemDetails || disableFieldsForNSP)}
              type={"text"}
              initialValue={(item.PrItemTxt && item.PrItemTxt.length > 40) ? item.PrItemTxt.slice(0, 40) : item.PrItemTxt}
              onChange={value =>
                applyChanges({ PrItemTxt: value }, item.PrItem)
              }
              maxInputLength={40}
            />
          );
        }
      },
      hasFeature(Features.RC_166206_INCOTERMS)
        ? {
          title: "Vendor Material No.",
          field: "VendorMaterial",
          cellStyle: { width: "11%" },
          sorting: false,
          render: (item: DocFlowItem, i) => {
            // const isCandexItem = (item as any).isItAddedFromPsl;
            const isCandexItem = isItCandex_IFrame();
            const isNestBuyCatalogItem =
              hasFeature(Features.RC_NESTBUY_CATALOG_ITEM_RESTRICTIONS) &&
              (item as any)?.PR_From_Item === "NESTBUY CATALOG";
            return (
              <CustomFastInput
                disabled={
                  isNestBuyCatalogItem
                    ? !!item.VendorMaterial
                    : hasFeature(Features.RC_178185_DISABLE_FILEDS_FOR_PUNCHOUT_CATALOG)
                      ? (
                        (props.punchOutCatalogDetails?.protocol === "cXML" &&
                          firstLineItem?.Psl_ID === "")
                          ? true
                          : (isItDeLsl_CXML() || isCandexItem)
                      )
                      : (isItDeLsl_CXML() || isCandexItem)
                }
                type={"text"}
                initialValue={item.VendorMaterial}
                onChange={value =>
                  applyChanges({ VendorMaterial: value }, item.PrItem)
                }
                maxInputLength={35}
              />
            );
          }
        }
        : null,
      fieldLevelConditions.isItEasyRequestPR
        ? {
          title: "Tax Code",
          field: "Taxcode",
          sorting: false,
          cellStyle: { width: "7%" },
          render: (item: DocFlowItem, i) => {
            return (
              <CustomFastSelect
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                  valueContainer: (base, state) => ({
                    ...base,
                    paddingLeft: 0
                  }),
                  indicatorSeparator: (base, state) => ({
                    ...base,
                    display: "none"
                  }),
                  control: (base, state) => ({
                    ...base,
                    backgroundColor: "transparent",
                    borderStyle: "none",
                    borderBottom: "1px solid",
                    borderRadius: "0px",
                    marginBottom: 7
                  })
                }}
                menuPortalTarget={document.body}
                isMulti={false}
                clearable={false}
                customDisplay={option => option.value}
                initialValue={{ value: item?.Taxcode }}
                options={taxCodes}
                onChange={value =>
                  applyChanges({ Taxcode: value?.value }, item.PrItem)
                }
                disabled={disbaleItemDetails}
              />
            );
          }
        }
        : null,
      {
        title: "Plant",
        field: "Plant",
        sorting: false,
        cellStyle: {
          width: hasFeature(Features.RC_169651_PLANT_EDIT_SHOW) ? "11%" : "3%"
        },
        render: (item: any, i) =>
          hasFeature(Features.RC_169651_PLANT_EDIT_SHOW) ? (
            <PlantComponent
              plant={item.Plant}
              compCode={
                firstLineItem?.CompCode || props.documentFlow.POCompanyCode
              }
              zone={firstLineItem?.SystemAlias}
              applyChange={applyPlantChanges}
            />
          ) : (
            item.Plant
          )
      },
      {
        title: "Delivery Date",
        field: "PrDeliveryDate",
        cellStyle: { width: "11%" },
        sorting: false,
        render: (item: DocFlowItem, i) => (
          <CustomFastDate
            initialValue={DateTime.fromFormat(
              item.PrDeliveryDate,
              "yyyyMMdd"
            ).toISO()}
            onChange={value => handleDeliveryDateChange(value, item)}
            disabled={disbaleItemDetails}
          />
        )
      },
      {
        title: "Delivery Address",
        field: "countryRegions",
        cellStyle: { width: "7%" },
        sorting: false,
        render: (item: DocFlowItem, i) => (
          <DeliveryAddressComponent
            documentFlow={props.documentFlow}
            punchOutCatalogDetails={props.punchOutCatalogDetails}
            disbaleItemDetails={disbaleItemDetails}
            countryRegions={countryRegions}
            lineItem={item}
            applyChanges={applyChanges}
          ></DeliveryAddressComponent>
        )
      },
      {
        title: "Spender",
        field: "RequsitionQty",
        sorting: false,
        cellStyle: { width: "5%" },
        render: (item: any, i) => (
          <SpenderComponent
            disbaleItemDetails={disbaleItemDetails}
            lineItem={item}
            applyChanges={
              hasFeature(Features.RC_165911_SPENDOR_UPDATE_WITH_PO_SENDING)
                ? applyChange
                : applyChanges
            }
          />
        )
      },
      {
        title: "Currency",
        field: "PrCurrency",
        sorting: false,
        cellStyle: { width: "7%" },
        render: (item: any, i) => {
          const isCandexItem = item?.PR_From_Item === "CANDEX CATALOG";
          const fieldLevelConditions = getCondtions(item);
          const isThereGRIR =
            fieldLevelConditions.isThereGR || fieldLevelConditions.isThereIR;
        
          const disableCurrency =
            isItDeLsl_CXML() ||
              isThereGRIR
              ? true
              : item?.isItAddedFromPsl
                ? disableField(
                  item?.isSupplierStatusMandatoryOrSoleSource,
                  item?.PrCurrency
                )
                : fieldLevelConditions.isItFO;

          return (
            <CustomFastSelect
              styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                valueContainer: (base, state) => ({ ...base, paddingLeft: 0 }),
                indicatorSeparator: (base, state) => ({
                  ...base,
                  display: "none"
                }),
                control: (base, state) => ({
                  ...base,
                  backgroundColor: "transparent",
                  borderStyle: "none",
                  borderRadius: 0,
                  borderBottom: disableCurrency
                    ? "1px solid hsl(0,0%,90%)"
                    : "1px solid",
                  marginBottom: 7
                })
              }}
              menuPortalTarget={document.body}
              isMulti={false}
              clearable={false}
              disabled={
                disableCurrency || disbaleItemDetails || disableFieldsForNSP
              }
              customDisplay={option => option.value}
              initialValue={
                item.PrQuantityUom ? { value: item.PrCurrency } : null
              }
              options={currencySet ? currencySet : []}
              onChange={handleCurrencyChanges}
            />
          );
        }
      },
      {
        title: "Unit",
        field: "PrQuantityUom",
        sorting: false,
        cellStyle: {
          width: hasFeature(Features.RC_167776_UOM_EDIT_AND_SAVE) ? "10%" : "2%"
        },
        render: (item: any, i) =>
          hasFeature(Features.RC_167776_UOM_EDIT_AND_SAVE) ? (
            disableFieldsForNSP ? (
              item.PrQuantityUom
            ) : (
              <UomComponent
                uom={item.PrQuantityUom}
                meterial={item.PrMaterial}
                applyChange={applyUomChanges}
              />
            )
          ) : (
            item.PrQuantityUom
          )
      },
      {
        title: "Price",
        field: "PrPriceRaw",
        sorting: false,
        cellStyle: { width: "7%" },
        render: (item: any, i) => {
          const fieldLevelConditions = getCondtions(item);
          console.log(
            "Line:",
            item.PrItem,
            "Copied:",
            item.isItCopiedLineItem,
            "AddedFromPsl:",
            item.isItAddedFromPsl,
            "PR_From_Item:",
            item.PR_From_Item,
            item
          );
          const priceValue = fieldLevelConditions.isItFO
            ? item?.PrPriceRaw
            : item?.PrNetPriceRaw;
          const disablePrice =
            isItCandex_IFrame() || isItDeLsl_CXML()
              ? true
              : item?.isItAddedFromPsl
                ? disableField(
                  item?.isSupplierStatusMandatoryOrSoleSource,
                  priceValue
                )
                : false;

          return (
            <div
              tabIndex={0}
              onBlur={() =>
                !disablePrice && setPriceToBeEdited(prevState => !prevState)
              }
            >
              {!priceToBeEdited && !disablePrice ? (
                <div
                  onClick={() => setPriceToBeEdited(prevState => !prevState)}
                >
                  <div
                    style={{
                      color: "hsl(0,0%,20%)",
                      borderBottom: "1px solid #707070",
                      paddingBottom: "9px"
                    }}
                  >
                    <Formatter amount={getDisplayedUnitPrice(item)} />
                  </div>
                </div>
              ) : (
                <div>
                  <CustomFastInput
                    type={"number"}
                    initialValue={getDisplayedUnitPrice(item)}
                    onChange={value => handlePriceChanges(value, item)}
                    disabled={
                      disablePrice || disbaleItemDetails || disableFieldsForNSP
                    }
                  />
                </div>
              )}
            </div>
          );
        }
      },
      {
        title: "Qty.",
        field: "PrQuantityRaw",
        sorting: false,
        cellStyle: { width: "5%" },
        render: (item: DocFlowItem, i) => {
          // const isCandexItem = item?.PR_From_Item === "CANDEX CATALOG";
          const isCandexItem = isItCandex_IFrame();
          const fieldLevelConditions = getCondtions(item);
          // const disableQuantity =
          //   isItDeLsl_CXML() || fieldLevelConditions.isItFO;
          const disableQuantity =
            isItDeLsl_CXML() ||
            fieldLevelConditions.isItFO;

          return (
            <div
              tabIndex={0}
              onBlur={() => setQuantityToBeEdited(prevState => !prevState)}
            >
              {!quantityToBeEdited && !disableQuantity ? (
                <div
                  onClick={() => setQuantityToBeEdited(prevState => !prevState)}
                >
                  <div
                    style={{
                      color: "hsl(0,0%,20%)",
                      borderBottom: "1px solid #707070",
                      paddingBottom: "9px"
                    }}
                  >
                    <Formatter amount={item.PrQuantityRaw} />
                  </div>
                </div>
              ) : (
                <div>
                  <CustomFastInput
                    disabled={
                      disableQuantity ||
                      disbaleItemDetails ||
                      disableFieldsForNSP
                    }
                    type={"number"}
                    initialValue={item.PrQuantityRaw}
                    onChange={value =>
                      handleQtyChanges(
                        isCandexServiceItem(item)
                          ? calcValueForCandex(value, true)
                          : value,
                        item
                      )
                    }
                  />
                </div>
              )}
            </div>
          );
        }
      },
      {
        title: "Per",
        field: "PrNetPriceUnit",
        sorting: false,
        cellStyle: { width: "5%" },
        render: (item: any, i) => {
          const fieldLevelConditions = getCondtions(item);
          const disablePer =
            isItCandex_IFrame() || isItDeLsl_CXML()
              ? true
              : item?.isItAddedFromPsl
                ? disableField(
                  item?.isSupplierStatusMandatoryOrSoleSource,
                  item?.PrNetPriceUnit
                )
                : fieldLevelConditions.isItFO;

          return (
            <div
              tabIndex={0}
              onBlur={() =>
                !disablePer && setPerUnitToBeEdited(prevState => !prevState)
              }
            >
              {!perUnitToBeEdited && !disablePer ? (
                <div
                  onClick={() => setPerUnitToBeEdited(prevState => !prevState)}
                >
                  <div
                    style={{
                      color: "hsl(0,0%,20%)",
                      borderBottom: "1px solid #707070",
                      paddingBottom: "9px"
                    }}
                  >
                    <Formatter amount={item.PrNetPriceUnit} />
                  </div>
                </div>
              ) : (
                <div>
                  <CustomFastInput
                    disabled={
                      disablePer || disbaleItemDetails || disableFieldsForNSP
                    }
                    type={"number"}
                    initialValue={item.PrNetPriceUnit}
                    onChange={value => handlePerUnitChanges(value, item)}
                  />
                </div>
              )}
            </div>
          );
        }
      },
      {
        title: "Sub Total",
        field: "PrPrice",
        sorting: false,
        cellStyle: { width: "6%" },
        render: (item: DocFlowItem, i) => (
          <div style={{ fontWeight: "bolder" }}>
            {// hasFeature(Features.RC_166302_SHOW_US_TAX_CALCULATIONS) ?
              hasFeature(Features.RC_166302_SHOW_US_TAX_CALCULATIONS) &&
                ((item?.Taxcode && item?.Taxcode === "I1") ||
                  (item?.Potaxcode && item?.Potaxcode === "I1")) &&
                props.documentFlow.POCompanyCode.substring(
                  0,
                  2
                ).toLocaleUpperCase() === "US" ? (
                showAmountOrAmountWithIcon(item, props.vertexData)
              ) : (
                <Formatter amount={getDisplayedSubtotal(item)} />
              )}
          </div>
        )
      },
      {
        sorting: false,
        title: "",
        field: "",
        cellStyle: { width: "2%" },
        render: (item: DocFlowItem) => {
          return (
            !disbaleItemDetails && (
              <ItemDetailsMoreButton
                lineItem={item}
                documentFlow={props.documentFlow}
                punchOutCatalogDetails={props.punchOutCatalogDetails}
                dispatchMethod={props.dispatchMethod}
              ></ItemDetailsMoreButton>
            )
          );
        }
      }
    ];
    return columns;
  };

  const theColumns = PRDetailColumns();
  const columnsNotNull = theColumns.filter(el => !isNil(el));

  const sortLineItemsData = data => {
    console.log("sapdata", data);
    const sortedData = data.sort((a, b) => {
      const lineItemA = Number(a.PrItem);
      const lineItemB = Number(b.PrItem);
      if (lineItemA < lineItemB) {
        return -1;
      }
      if (lineItemA > lineItemB) {
        return 1;
      }
      return 0;
    });
    console.log("sorteddata", sortedData);
    return sortedData;
  };

  return (
    <EditDetailsTable
      className={`${docFlowTableClass} ${removeBorderForCheckBox}`}
    >
      <MuiThemeProvider theme={theme}>
        <MaterialTable
          style={{
            boxShadow: "none",
            zIndex: 999
          }}
          isLoading={!props.lineItems}
          columns={columnsNotNull}
          data={sortedData}
          components={{
            OverlayLoading: () => <TableLoadingComponent />,
            Cell: props => <PRStyledCell {...props} />
          }}
          onSelectionChange={dataClicked => {
            props.setSelectedData(dataClicked);
          }}
          options={{
            selection: disbaleItemDetails ? false : true,
            actionsColumnIndex: -1,
            paging: false,
            toolbar: false,
            rowStyle: {
              border: "none",
              padding: "10px 5px",
              fontSize: ".8rem",
              color: "#7c7777",
              whiteSpace: "nowrap",
              height: "60px"
            },
            headerStyle: {
              fontSize: ".8rem",
              fontWeight: "bold",
              height: "60px",
              padding: "10px 5px",
              whiteSpace: "nowrap",
              color: "#5D5858",
              backgroundColor: "#F5F5F5",
              borderBottom: "none"
            }
          }}
        />
      </MuiThemeProvider>
    </EditDetailsTable>
  );
};
